import Head from 'next/head';
import { InspirationFeed } from '@/components/demand/InspirationFeed';

export default function InspirationFeedPage() {
  return (
    <>
      <Head>
        <title>Inspiration Feed | Sizzle</title>
        <meta
          name="description"
          content="See what worked, why it worked, and what to post next. Real demand generation examples from CPG brands."
        />
      </Head>

      <InspirationFeed quickFiltersPosition="withFilters" />
    </>
  );
}
